import { render, staticRenderFns } from "./OperationTypeCreateContainer.vue?vue&type=template&id=20ec4465"
import script from "./OperationTypeCreateContainer.vue?vue&type=script&lang=js"
export * from "./OperationTypeCreateContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports